import { Divider, Typography } from "@mui/material";
import React from "react";

function Footer() {
  return (
    <div
      style={{ width: "100%", marginTop: "auto", height: 40, paddingLeft: 20 }}
    >
      <Typography variant="body2">Copyright &copy; 2023 Maintocoin</Typography>
    </div>
  );
}

export default Footer;
